/* global process */
import axios from 'axios';
import { isNil } from 'lodash';
import { AuthService } from '@/services';
import store from '@/store';
import { EventBus } from '@/event-bus';
import Cookies from 'js-cookie';

const furtherAuthAPI = axios.create({
  baseURL: process.env.VUE_APP_API_VERSION === 'dev' ? process.env.VUE_APP_SAM_API_URL : `${window.location.origin}/`,
  headers: {
    'x-api-key': process.env.VUE_APP_TOKEN_API_KEY,
    'x-client-version': process.env.VUE_APP_CLIENT_VERSION,
  },
});

furtherAuthAPI.interceptors.response.use(
  (response) => {
    if (isNil(response)) {
      throw Error('Response is undefined or null');
    }

    if (response.status === 204) {
      return false;
    }

    return response;
  },
  (error) => {
    if (Cookies.get('idToken') && error.response.status === 401) {
      AuthService.signOutUser();
    }

    let returnedError = error.response;

    // If this data is an empty string or deposits (we handle based on status code), return the response
    if (returnedError.config.url.endsWith('scheduled-deposits') || typeof returnedError.data === 'string' && !returnedError.data.length) {
      return Promise.reject(returnedError);
    }

    // Otherwise return the data
    return Promise.reject(returnedError.data);
  },
);

furtherAuthAPI.interceptors.request.use((request) => {
  if (store.getters.user && store.getters.user.role === 'CSR') {
    if (request.method === 'post' || request.method === 'put') {
      EventBus.$emit('openModal', 'Error', {
        message: 'global_csr-error',
      });

      return false;
    }
  }

  return request;
});

export default furtherAuthAPI;
